import getCheapestRoomData from '@stencil/hotels-utils/src/get-cheapest-room-data';

export type EmiDataType = ReturnType<typeof getCheapestRoomData>['emiData'];
// import { ValuesType, Optional } from 'utility-types';
export enum FetchStatusType {
  NOT_STARTED = 'NOT_STARTED',
  PENDING = 'PENDING',
  RESOLVED = 'RESOLVED',
  REJECTED = 'REJECTED',
}
export interface IDayUseSrpStoreState {
  hasData: boolean | null;
  isLoading: boolean;
  displayOverlay: boolean;
  srpConfig: IDayUseSrpConfig;
  srpData: IDayUseSrpData;
  partner: string;
  srpOfferData: ISrpOfferData;
  isSEO: boolean;
  isMetaSRP: boolean;
  isCRMSRP: boolean;
  isSEMSRP: boolean;
  hasStoreGoSuggestData: boolean;
  seoData: IDayUseSrpSeoData;
  selectedHotelItemData: selectedHotelItemData;
  // selectedRegionCity: IRegionCity;
  previousBookingRecommendation;
  isSortandFilterCloseButtonClicked: boolean;
  isNextWithNoEndAndNoData: boolean;
}

export interface selectedHotelItemData {
  showPrice?: number;
}

export interface ISrpOfferData {
  (key: string): {data: Array<ISrpOfferDataItem>; error: string};
}

export interface IDayUseSrpSeoData {
  faqs: Array<IFaqData>;
  article: {
    desc: string;
    title: string;
  };
  meta: Array<object>;
  seoLinks: Array<object>;
  pageTitle: string;
  pageHeading: string;
  breadCrumbData: Array<object>;
  filterLinks: Array<{
    link_data: Array<object>;
    title: string;
  }>;
  footerLinks: Array<{
    link_data: Array<object>;
    title: string;
  }>;
  templateName: string;
  numberOfHotelsinFirstLoad?: number;
  showHotelCardDesc?: boolean;
}

export interface ISrpOfferDataItem {
  ty?: string;
  pa?: number;
  pt?: string;
  st?: string;
}

interface IFaqData {
  q: string;
  a: string;
}

export interface IDayUseSrpConfig {
  filter?: IDayUseFilters;
  metaPartner?: string;
  s?: string; // sorting
  cur?: string; // currency
  im?: boolean;
  ibp?: string;

  hmd?: string;
  // next?: string;
  pc?: string;
  pcf?: number;
  la?: string;
  lo?: string;
  rank?: string;
  isGds?: boolean;
  overriderankvhids?: string;
  overriderankvhidName?: string;
  segmentSliderHctxIndex?: number;
  currentExpandedStickyFilter?: string;
}

// export interface IRegionCity {
//   id?: string;
//   ind?: string;
//   name?: string;
// }

export interface ILocation_Search {
  id_type: string;
  loc_id: string;
  n: string;
}

export interface ISrpQueryParams {
  partner: string;
  cityName?: string;
  cityId: string;
  hotelQuery?: string;
  entityId?: string;
  metaPartner?: string;
  hquery?: string;
}

export interface IDayUseSrpData {
  augur_exp?: string;
  city_meta_info?: ICityMetaInfo;
  data: Array<IHotelData>;
  next: string;
  hydra_seg: Array<string>;
  error?: boolean;
  backfill_data?: BackFillData;
  hermes_exp?: HermesExp;
}

export interface HermesExp {
  hero_image: number;
  showChildBed: number;
  new_user_comm: number;
  apeintl_gi: number;
  bpg: number;
  [key: string]: any;
}

export interface BackFillData {
  data: Array<IHotelData>;
  heading: string;
  sub_heading: string;
}

export interface IHotelData {
  adp: number;
  ami?: [number];
  bt?: string;
  fcp: string;
  hn: string;
  hr?: number;
  hti?: number;
  l: string;
  lib?: string;
  opr: number;
  spr: number;
  do?: number;
  pxper: number;
  rec?: number;
  rtn: string;
  si: Array<string>;
  hi: Array<ISRPHotelThumbnailImages>;
  oip?: Array<IPersuasionText>;
  bbp?: Array<IPersuasionText>;
  cp1?: Array<IPersuasionText>;
  cp2?: Array<IPersuasionText>;
  arp?: Array<IPersuasionText>;
  bpp?: Array<IPersuasionText>;
  tnc?: number;
  ofs?: string;
  cbm?: string;
  app?: Array<IPersuasionText>;
  bp?: Array<IPersuasionText>;
  tgi?: Array<number>;
  rac?: Array<number>;
  distl?: Array<string>;
  pph?: string;
  dspr?: number;
  npp?: Array<IPersuasionText>;
  af?: string[]; // list of applied filter codes
  // aci: [number];
  // cbm: string;
  // ch: string;
  // chc: string;
  // cot: string;
  // dtc: number;
  emi?: EmiDataType['emi'];
  emid?: EmiDataType['emiRates'];
  // gos_flag: number;
  gr?: number;
  grc?: number;
  gri?: number;
  // grti: number;
  // gseg: string;
  // gsv: string;
  hc: number;
  // hfe: number;
  // hmd: string;
  // ibp: string;
  // is_aa: number;
  // la: number;
  // lo: number;
  // nbi: [number];
  // ofs: string;
  // oi: [number];
  // pm: number;
  // pph: string;
  // pr: number;
  // ptl: []

  // sb: number;
  // sld: string;
  t?: string;
  // tax: number;
  // ti: number;
  ut?: string;
  rnpl?: number;
  // vi: number;
  slot_prc: [];
  fnp: {};
  ts: string;
  hsos: string;
}

export interface ISRPHotelThumbnailImages {
  si: string; // for small images
  mi: string; // for medium images
}

export interface IPersuasionText {
  pt: string;
  ccd?: IPersuasionColor;
  htd?: {
    h?: string;
    ht?: Array<string>;
    ft?: string;
    hec?: IPersuasionColor;
    hoc?: IPersuasionColor;
    ic?: string;
  };
  fd?: IDayUseFilters;
  ic?: string;
  ui?: string;
}

export interface IPersuasionColor {
  tc?: string;
  bgc?: string;
}

export interface ICityMetaInfo {
  am: Array<string>;
  ata: Array<string>;
  aty: Array<string>;
  tabs: Array<string>;
  qf?: Array<IQuickFilter>;
  tl?: Array<{id: string; n: string}>;
  flt: Array<{n: string; fd: {(key: string): string}}>;
  hccm?: {[id: string]: string};
  gsm?: Array<string>;
  hcl?: Array<string>;
  dln?: Array<string>;
  co: string;
  ct: string;
  dsl: [IDsl];
  lli: {
    [K: string]: string; // values are location voyager ids of static locations used in location and hotel search filter for checkboxes
  };
  ifilters: {
    filterType: string;
    flist: Array<{
      t: string;
      f: Object;
    }>;
    t: string;
  };
  cfilters: {
    flist: Array<{
      t: string;
      f: Object;
      ic: string;
      slg: string;
    }>;
    t: string;
  };
  vcid?: string;
  utn?: string;
}

export interface IQuickFilter {
  n: string;
  fd: IDayUseFilters;
  o?: Array<IQuickFilterItem>;
  m?: number;
}

export interface IQuickFilterItem {
  fid?: string;
  n?: string;
  c?: number;
}

export interface IUpdateDayuseSRPSortFilterFlags {
  isCloseButtonClicked: boolean;
}
export interface IDayUseFilters {
  range_ugc?: Array<number>;
  tags?: Array<string>;
  tag?: string;
  lid?: Array<string>;
  utag?: Array<IQuickFilterItem>;
  qf?: Array<IQuickFilter>;
  step_range?: Array<IStepRange>;
  star?: Array<number>;
  type?: Array<string>;
  chain?: Array<string>;
  amenities?: Array<string>;
  location_search?: Array<ILocation_Search>;
  fbfi?: number;
  pah?: number;
  isrnpl?: number;
  gt?: number;
  fcp?: number;
  ht?: string;
  dis?: Array<string>;
  sf?: [];
}

export interface IStepRange {
  min: number;
  max: number;
}

export interface IUpdateDayUseSeoFlags {
  isSEO?: boolean;
  isSeoUnif?: boolean;
}

export type IHotelDataType =
  | 'SegmentSlider'
  | 'SignUpBanner'
  | 'SmartEngageBanner'
  | 'ExploreBySection';

export const UPDATE_DAY_USE_SRP_CONFIG = 'UPDATE_DAY_USE_SRP_CONFIG';
export const FETCH_DAY_USE_SRP_DATA = 'FETCH_DAY_USE_SRP_DATA';
export const UPDATE_DAY_USE_FILTER = 'UPDATE_DAY_USE_FILTER';
export const TOGGLE_DAY_USE_LOADING = 'TOGGLE_DAY_USE_LOADING';
export const UPDATE_DAY_USE_SRP_SEO_DATA = 'UPDATE_DAY_USE_SRP_SEO_DATA';
export const UPDATE_DAY_USE_SEO_FLAGS = 'UPDATE_DAY_USE_SEO_FLAGS';
export const FLUSH_DAY_USE_SRP_DATA = 'FLUSH_DAY_USE_SRP_DATA';
export const UPDATE_DAY_USE_EXPANDED_STICKY_FILTER = 'UPDATE_DAY_USE_EXPANDED_STICKY_FILTER';
export const RESET_DAY_USE_SRP_HOTEL_LIST = 'RESET_DAY_USE_SRP_HOTEL_LIST';
export const RESET_DAY_USE_FILTER = 'RESET_DAY_USE_FILTER';
export const UPDATE_DAY_USE_SORT_FILTER_CLOSE_FLAG = 'UPDATE_DAY_USE_SORT_FILTER_CLOSE_FLAG';
export const RESET_DAY_USE_SRP = 'RESET_DAY_USE_SRP';

export interface IUpdate_Dayuse_Srp_Config {
  type: typeof UPDATE_DAY_USE_SRP_CONFIG;
  actionData: IDayUseSrpConfig;
}
export interface IFetch_Dayuse_Srp_Data {
  type: typeof FETCH_DAY_USE_SRP_DATA;
  actionData: IDayUseSrpData;
  loadingMore?: boolean;
  isNextWithNoEndAndNoData?: boolean;
}

export interface IToggle_Dayuse_Loading {
  type: typeof TOGGLE_DAY_USE_LOADING;
  isLoading: IDayUseSrpStoreState['isLoading'];
  displayOverlay: IDayUseSrpStoreState['displayOverlay'];
}

export interface IUpdate_Dayuse_Filter {
  type: typeof UPDATE_DAY_USE_FILTER;
  actionData: IDayUseFilters;
}

export interface IUpdate_Dayuse_Srp_Seo_Data {
  type: typeof UPDATE_DAY_USE_SRP_SEO_DATA;
  actionData: IDayUseSrpSeoData;
}

export interface IReset_Dayuse_Filter {
  type: typeof RESET_DAY_USE_FILTER;
}

export interface IReset_Dayuse_Srp {
  type: typeof RESET_DAY_USE_SRP;
}

export interface IReset_Day_Use_Srp_Hotel_List {
  type: typeof RESET_DAY_USE_SRP_HOTEL_LIST;
}

export interface IFlush_Dayuse_Srp_Data {
  type: typeof FLUSH_DAY_USE_SRP_DATA;
}

export interface IUpdate_Dayuse_SEO_Flags {
  type: typeof UPDATE_DAY_USE_SEO_FLAGS;
  actionData: IUpdateDayUseSeoFlags;
}

export interface IUPDATE_Dayuse_EXPANDED_STICKY_FILTER {
  type: typeof UPDATE_DAY_USE_EXPANDED_STICKY_FILTER;
  actionData: string;
}
export interface IUpdate_Day_Use_SRP_SORT_FILTER_CLOSE_Flags {
  type: typeof UPDATE_DAY_USE_SORT_FILTER_CLOSE_FLAG;
  actionData: IUpdateDayuseSRPSortFilterFlags;
}
export type DayUseSrpActionTypes =
  | IUpdate_Dayuse_Srp_Config
  | IUpdate_Dayuse_Filter
  | IToggle_Dayuse_Loading
  | IFetch_Dayuse_Srp_Data
  | IUpdate_Dayuse_Srp_Seo_Data
  | IUpdate_Dayuse_SEO_Flags
  | IUpdateDayUseSeoFlags
  | IFlush_Dayuse_Srp_Data
  | IUPDATE_Dayuse_EXPANDED_STICKY_FILTER
  | IReset_Day_Use_Srp_Hotel_List
  | IReset_Dayuse_Filter
  | IUpdate_Day_Use_SRP_SORT_FILTER_CLOSE_Flags
  | IUpdateDayuseSRPSortFilterFlags
  | IReset_Dayuse_Srp;
